/**
 * PawLab film hero — autoplay beats in one viewport. homepage-flash-v3:
 * unify banner height; never re-touch beat0 bg on resize; debounce resize;
 * syncOffset only on init/resize (not every 80ms tick).
 */
(function () {
  var BEAT_MS = 5000;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function headerOffsetPx() {
    var header =
      document.querySelector("#header-component") ||
      document.querySelector("header-component") ||
      document.querySelector(".shopify-section-header-group") ||
      document.querySelector('[id*="header-group"]');
    var h = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      h = Math.max(r.height, header.offsetHeight || 0);
    }
    var cssVar = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
      .trim();
    if (cssVar && cssVar.endsWith("px")) {
      var parsed = parseFloat(cssVar);
      if (!isNaN(parsed) && parsed > 40) h = Math.max(h, parsed);
    }
    if (!h || h < 48) h = window.innerWidth < 750 ? 76 : 120;
    return Math.round(h);
  }

  function layoutWidth() {
    var client = document.documentElement ? document.documentElement.clientWidth : 0;
    return client || window.innerWidth || 1280;
  }

  function pawlabFilmBannerHeight(vw, vh, headerPx) {
    var room = Math.max(280, vh - headerPx - 12);
    if (vw < 750) return Math.max(400, Math.min(room, 520));
    var sixteenNine = Math.round((vw * 9) / 16);
    var cinema = Math.round((vw * 9) / 21);
    if (vw >= 1100) return Math.max(352, Math.min(608, cinema, room));
    return Math.max(320, Math.min(room, sixteenNine, 576));
  }

  function ensureBeat0Bg(sticky) {
    if (!sticky || sticky.getAttribute("data-beat0-applied") === "1") return;
    sticky.style.setProperty("background-color", "#f4efe8", "important");
    var beat0bg = sticky.getAttribute("data-beat0-bg");
    if (beat0bg) {
      sticky.style.setProperty("background-image", "url('" + beat0bg + "')", "important");
      sticky.style.setProperty("background-size", "cover", "important");
      sticky.style.setProperty("background-position", "center 48%", "important");
      sticky.style.setProperty("background-repeat", "no-repeat", "important");
    }
    sticky.setAttribute("data-beat0-applied", "1");
  }

  function syncOffset(root) {
    var px = headerOffsetPx();
    var section = root.closest(".pawlab-film-section") || root.parentElement;
    var sticky = root.querySelector("[data-film-sticky]");
    var viewportW = layoutWidth();
    var frameH = pawlabFilmBannerHeight(viewportW, window.innerHeight || 900, px);
    var want = frameH + "px";

    root.style.setProperty("--pawlab-film-header-offset", px + "px");

    if (section) {
      section.style.setProperty("--pawlab-film-header-offset", px + "px");
      section.style.setProperty("width", "100%", "important");
      section.style.setProperty("max-width", "100%", "important");
      section.style.setProperty("min-width", "0", "important");
      section.style.setProperty("padding", "0px", "important");
      section.style.setProperty("margin", "0px", "important");
      section.style.setProperty("align-self", "stretch", "important");
      section.style.setProperty("flex", "0 0 auto", "important");
      section.style.setProperty("box-sizing", "border-box", "important");
    }

    if (root.style.height !== want) {
      root.style.setProperty("width", "100%", "important");
      root.style.setProperty("max-width", "100%", "important");
      root.style.setProperty("min-width", "0", "important");
      root.style.setProperty("margin-left", "0px", "important");
      root.style.setProperty("margin-right", "0px", "important");
      root.style.setProperty("padding-left", "0px", "important");
      root.style.setProperty("padding-right", "0px", "important");
      root.style.setProperty("box-sizing", "border-box", "important");
      root.style.setProperty("height", want, "important");
      root.style.setProperty("min-height", want, "important");
      root.style.setProperty("max-height", want, "important");
    }

    if (sticky) {
      sticky.style.setProperty("width", "100%", "important");
      sticky.style.setProperty("min-width", "100%", "important");
      sticky.style.setProperty("height", "100%", "important");
      sticky.style.setProperty("min-height", "100%", "important");
      ensureBeat0Bg(sticky);
      sticky.style.setProperty("position", "relative", "important");
      sticky.style.setProperty("top", "auto", "important");
      sticky.style.setProperty("overflow", "hidden", "important");
      sticky.style.setProperty("display", "block", "important");
      sticky.style.setProperty("box-sizing", "border-box", "important");
      sticky.style.setProperty("border-radius", "0", "important");
    }
  }

  function initFilm(root) {
    if (root.dataset.pawlabFilmInit) return;
    root.dataset.pawlabFilmInit = "1";
    root.setAttribute("data-film-mode", "autoplay");

    var fill = root.querySelector("[data-film-fill]");
    var slides = Array.prototype.slice.call(root.querySelectorAll(".pawlab-film__slide"));
    var texts = Array.prototype.slice.call(root.querySelectorAll(".pawlab-film__beat"));
    var ticks = Array.prototype.slice.call(root.querySelectorAll(".pawlab-film__tick"));
    var count = Math.max(slides.length, texts.length, 1);
    var currentBeat = 0;
    var started = Date.now();
    var paused = false;

    var beatToken = 0;
    function applyBeat(i) {
      currentBeat = ((i % count) + count) % count;
      texts.forEach(function (el, idx) {
        el.classList.toggle("is-on", idx === currentBeat);
      });
      slides.forEach(function (el, idx) {
        el.classList.toggle("is-on", idx === currentBeat);
        el.style.opacity = idx === currentBeat ? "1" : "0";
      });
      ticks.forEach(function (el, idx) {
        el.classList.toggle("is-active", idx === currentBeat);
      });
      started = Date.now();
    }
    function setBeat(i) {
      var next = ((i % count) + count) % count;
      var img = slides[next] && slides[next].querySelector("img");
      if (img && !(img.complete && img.naturalWidth > 0)) {
        var token = ++beatToken;
        var go = function () {
          if (token !== beatToken) return;
          applyBeat(next);
        };
        img.addEventListener("load", go, { once: true });
        img.addEventListener("error", go, { once: true });
        return;
      }
      applyBeat(next);
    }

    function progressWidth() {
      if (reducedMotion() || paused) {
        return ((currentBeat + 1) / count) * 100;
      }
      var local = Math.min(1, (Date.now() - started) / BEAT_MS);
      return ((currentBeat + local) / count) * 100;
    }

    function tickProgress() {
      if (fill) fill.style.width = progressWidth().toFixed(2) + "%";
      if (!reducedMotion() && !paused && Date.now() - started >= BEAT_MS) {
        setBeat(currentBeat + 1);
      }
    }

    var resizeRaf = 0;
    function onResize() {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = 0;
        syncOffset(root);
      });
    }

    window.addEventListener("resize", onResize, { passive: true });
    function resume() {
      if (reducedMotion()) {
        paused = true;
        return;
      }
      paused = false;
      started = Date.now();
    }

    root.addEventListener("mouseenter", function () {
      paused = true;
    });
    root.addEventListener("mouseleave", resume);
    root.addEventListener("focusin", function () {
      paused = true;
    });
    root.addEventListener("focusout", resume);
    root.addEventListener(
      "touchstart",
      function () {
        paused = true;
      },
      { passive: true }
    );

    ticks.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setBeat(Number(btn.getAttribute("data-beat")) || 0);
        resume();
        tickProgress();
      });
    });

    setBeat(0);
    syncOffset(root);
    tickProgress();
    if (!reducedMotion()) setInterval(tickProgress, 80);
  }

  function boot() {
    document.querySelectorAll("[data-pawlab-film]").forEach(initFilm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
